/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useState } from "react";

import {
  Container,
  TextField,
  Button,
  MenuItem,
  Box,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  Alert,
  Typography,
} from "@mui/material";

import ModalDialog from "./ModalDialog";
import PropTypes from "prop-types";
import axios from "axios";
import { InfoOutlined } from "@mui/icons-material";
import loaderHelper from "../loader/loaderHelper";
import AddressSearch from "../address/AddressSearch";

const baseUrl = process.env.API_GATEWAY || "https://satmon.fly.dev";
const GOOGLE_API_KEY = "AIzaSyDRQ31td2ZA3Y0IWbpit6018Z2o-7cV3YA";

export default function AddStationDialog(props) {
  const {
    openDialog,
    setOpenDialog,
    stationObject,
    celestrakId,
    callbackFunc,
  } = props;

  const [errors, setErrors] = useState({});
  const [stationId, setStationId] = useState(0);
  const [messageOption, setMessageOption] = useState({
    show: false,
    severity: "success",
    messageText: "",
  });

  const [option, setOption] = useState({
    name: "",
    latitude_degn: "",
    longitude_dege: "",
    altitude_m: "",
    rx_antenna_gain_db: "",
    rx_antenna_efficiency: "",
    rx_noise_fig_db: "",
    coax_length_ft: "",
    lnb_gain_db: "",
    lnb_noise_fig_db: "",
    lna_feed_loss_db: "",
    mispointing_loss_db: "",
  });

  useEffect(() => {
    if (!stationObject) return;
    setOption({
      name: stationObject.name,
      latitude_degn: stationObject.latitude_degn,
      longitude_dege: stationObject.longitude_dege,
      altitude_m: stationObject.altitude_m,
      rx_antenna_gain_db: stationObject.rx_antenna_gain_db,
      rx_antenna_efficiency: stationObject.rx_antenna_efficiency,
      rx_noise_fig_db: stationObject.rx_noise_fig_db,
      coax_length_ft: stationObject.coax_length_ft,
      lnb_gain_db: stationObject.lnb_gain_db,
      lnb_noise_fig_db: stationObject.lnb_noise_fig_db,
      lna_feed_loss_db: stationObject.lna_feed_loss_db,
      mispointing_loss_db: stationObject.mispointing_loss_db,
    });
    if (stationObject.hasOwnProperty("id")) {
      console.log("Station Id => " + stationObject.id);
      setStationId(stationObject.id);
    }
  }, []);

  useEffect(() => {
    if (openDialog) {
    }
  }, [openDialog]);

  const showAlerMessage = (text, severity) => {
    setMessageOption({
      ...messageOption,
      severity: severity,
      messageText: text,
      show: true,
    });
  };

  const onCloseFunc = () => {
    setOpenDialog(false);
    loaderHelper().close();
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "latitude_degn") {
      if (value < -90 || value > 90) return;
      else value = checkDecimalValue(value, 6);
    }

    if (name === "longitude_dege") {
      if (value < -180 || value > 180) return;
      else value = checkDecimalValue(value, 6);
    }

    if (name == "altitude_m") {
      if (value < -9000 || value > 9000) return;
      else value = checkDecimalValue(value, 2);
    }

    if (
      name === "rx_antenna_gain_db" ||
      name === "rx_noise_fig_db" ||
      name === "lnb_gain_db" ||
      name === "lnb_noise_fig_db" ||
      name === "lna_feed_loss_db" ||
      name === "mispointing_loss_db"
    ) {
      if (value < 0) return;
      else {
        value = checkDecimalValue(value, 2);
      }
    }

    if (name === "rx_antenna_efficiency") {
      if (value < 0 || value > 1) return;
      else value = checkDecimalValue(value, 3);
    }

    if (name == "coax_length_f") {
      if (value < 0 || value > 99999.9) return;
      else value = checkDecimalValue(value, 2);
    }

    // Remove error message when the field is filled
    if (value.trim()) {
      const { [name]: removedError, ...restErrors } = errors;
      setErrors(restErrors);
    } else {
      setErrors({ ...errors, [name]: "This field cannot be empty" });
    }

    setOption({
      ...option,
      [name]: value,
    });
  };

  const checkDecimalValue = (value, decimal) => {
    const decimalVal = value.split(".");
    if (decimalVal.length == 2) {
      if (decimalVal[1].length > decimal - 1) {
        return parseFloat(value).toFixed(decimal);
      }
    }
    return value;
  };

  const checkValidation = () => {
    const newErrors = {};
    Object.keys(option).forEach((key) => {
      if (!option[key] || !option[key].toString().trim()) {
        newErrors[key] = "This field cannot be empty";
      }
    });

    if (Object.keys(newErrors).length > 0) setErrors(newErrors);

    console.log(newErrors);

    return Object.keys(newErrors).length > 0;
  };

  const handleSubmit = async (e) => {
    try {
      if (checkValidation()) return;
      loaderHelper().open();
      showAlerMessage("Saving Rx Station " + option.name + " ...", "info");

      let response;
      let url = `${baseUrl}/rx-stations/${celestrakId}`;

      const saveData = {
        name: option.name,
        latitude_degn: parseFloat(option.latitude_degn).toFixed(6),
        longitude_dege: parseFloat(option.longitude_dege).toFixed(6),
        altitude_m: parseFloat(option.altitude_m).toFixed(2),
        rx_antenna_gain_db: parseFloat(option.rx_antenna_gain_db).toFixed(2),
        rx_antenna_efficiency: parseFloat(option.rx_antenna_efficiency).toFixed(
          3
        ),
        rx_noise_fig_db: parseFloat(option.rx_noise_fig_db).toFixed(2),
        coax_length_ft: parseFloat(option.coax_length_ft).toFixed(2),
        lnb_gain_db: parseFloat(option.lnb_gain_db).toFixed(2),
        lnb_noise_fig_db: parseFloat(option.lnb_noise_fig_db).toFixed(2),
        lna_feed_loss_db: parseFloat(option.lna_feed_loss_db).toFixed(2),
        mispointing_loss_db: parseFloat(option.mispointing_loss_db).toFixed(2),
      };
      if (stationId > 0) {
        response = await axios.put(url + "/" + stationId, saveData);
      } else {
        response = await axios.post(url, saveData);
      }

      showAlerMessage("Rx Station succesfully saved " + option.name, "success");
      callbackFunc ? callbackFunc(response.data) : null;
      setOpenDialog(false);
    } catch (error) {
      console.error("Error:", error);
      showAlerMessage("Error while saving Rx Station " + option.name, "error");
    }

    loaderHelper().close();
  };

  const handleAddressSelect = async (val) => {
    if (val.lat && val.lon) {
      const lat = val.lat?.toFixed(6);
      const lon = val.lon?.toFixed(6);
      const alt = val.elev?.toFixed(2);
      setOption({
        ...option,
        latitude_degn: lat,
        longitude_dege: lon,
        altitude_m: alt,
      });
    }
  };

  return (
    <>
      <ModalDialog
        dialogTitle={"Station Configuration Screen"}
        openModal={openDialog}
        setOpenModal={setOpenDialog}
        onSubmit={handleSubmit}
        submitButtonText={"Save"}
        onCancel={onCloseFunc}
        dialogContent={
          <Container>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
              <TextField
                fullWidth
                label="Station Name"
                name="name"
                value={option.name}
                onChange={handleChange}
                margin="dense"
                size="small"
                error={errors.name ? true : false}
              />
              {stationId == 0 && (
                <AddressSearch onAddressSelect={handleAddressSelect} />
              )}
              <div className="configuration-row">
                <TextField
                  fullWidth
                  label="Latitude (°N)"
                  name="latitude_degn"
                  type="number"
                  value={option.latitude_degn}
                  onChange={handleChange}
                  margin="dense"
                  size="small"
                  error={errors.latitude_degn ? true : false}
                />
                <TextField
                  label="Longitude (°E)"
                  name="longitude_dege"
                  type="number"
                  value={option.longitude_dege}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.longitude_dege ? true : false}
                />
              </div>
              <div className="configuration-row">
                <TextField
                  label="Altitude (m)"
                  name="altitude_m"
                  type="number"
                  value={option.altitude_m}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.altitude_m ? true : false}
                />
                <TextField
                  label="RX Antenna Gain (dB)"
                  name="rx_antenna_gain_db"
                  type="number"
                  value={option.rx_antenna_gain_db}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.rx_antenna_gain_db ? true : false}
                />
              </div>
              <div className="configuration-row">
                <TextField
                  label="RX Antenna Efficiency"
                  name="rx_antenna_efficiency"
                  type="number"
                  value={option.rx_antenna_efficiency}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.rx_antenna_efficiency ? true : false}
                />
                <TextField
                  label="RX Noise Figure (dB)"
                  name="rx_noise_fig_db"
                  type="number"
                  value={option.rx_noise_fig_db}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.rx_noise_fig_db ? true : false}
                />
              </div>
              <div className="configuration-row">
                <TextField
                  label="Coax Length (ft)"
                  name="coax_length_ft"
                  type="number"
                  value={option.coax_length_ft}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.coax_length_ft ? true : false}
                />
                <TextField
                  label="LNB Gain (dB)"
                  name="lnb_gain_db"
                  type="number"
                  value={option.lnb_gain_db}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.lnb_gain_db ? true : false}
                />
              </div>
              <div className="configuration-row">
                <TextField
                  label="LNB Noise Figure (dB)"
                  name="lnb_noise_fig_db"
                  type="number"
                  value={option.lnb_noise_fig_db}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.lnb_noise_fig_db ? true : false}
                />
                <TextField
                  label="LNA Feed Loss (dB)"
                  name="lna_feed_loss_db"
                  type="number"
                  value={option.lna_feed_loss_db}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  size="small"
                  error={errors.lna_feed_loss_db ? true : false}
                />
              </div>
              <TextField
                label="Mispointing Loss (dB)"
                name="mispointing_loss_db"
                type="number"
                value={option.mispointing_loss_db}
                onChange={handleChange}
                fullWidth
                margin="dense"
                size="small"
                error={errors.mispointing_loss_db ? true : false}
              />
            </Box>
            {messageOption.show && (
              <Alert
                icon={<InfoOutlined fontSize="inherit" />}
                severity={messageOption.severity}
              >
                {messageOption.messageText}
              </Alert>
            )}
          </Container>
        }
      />
    </>
  );
}

AddStationDialog.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  stationObject: PropTypes.object,
  celestrakId: PropTypes.string.isRequired,
  callbackFunc: PropTypes.func,
};
